import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {LiveEventEventTypeFormFieldsType} from "../../../types";

export function LiveEventEventTypeTopicTypeSingleEventCustomDurationFormField() {
  const {control, watch} = useFormContext<LiveEventEventTypeFormFieldsType>();

  const duration = watch("duration");
  const isCustomSelected = duration === "-1";

  return (
    <div>
      {isCustomSelected && (
        <FormField
          id={"singleEvenCustomDuration"}
          label={"Event custom duration (In minutes)"}
          renderInput={(id) => (
            <Controller
              control={control}
              name="customDuration"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <Space direction="vertical" size={16} style={{display: "flex"}}>
                  <Input
                    id={id}
                    status={error?.message ? "error" : ""}
                    onChange={onChange}
                    onBlur={onBlur}
                    size="large"
                    value={value ? value : undefined}
                    placeholder={"Duration in minutes"}
                    ref={ref}
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )}
        />
      )}
    </div>
  );
}
